import { useGetFilePreviewRenderer } from "./hooks/useFilePreviewRenderer";
import type { FilePreviewProps } from "./types/FilePreviewerTypes";
import {
  Typography,
  TypographyVariants
} from "@certa/catalyst/components/Typography";
import { Stack } from "@certa/catalyst/layouts/Stack";
import { Loader } from "@certa/blocks";

const FilePreviewer = ({
  url,
  fileName,
  disablePreview = false,
  filePreviewDataSource,
  ...restProps
}: FilePreviewProps) => {
  const { DocRendererComp, isFetchingFileMimeType } = useGetFilePreviewRenderer(
    {
      url,
      disableMimeTypeCheck: disablePreview,
      filePreviewDataSource
    }
  );
  return DocRendererComp ? (
    DocRendererComp === "NO_RENDERER_FOUND" || disablePreview ? (
      <Stack height="18rem" width="100%" align="center" justify="center">
        <Typography variant={TypographyVariants.BODY_BOLD}>
          No preview available
        </Typography>
      </Stack>
    ) : isFetchingFileMimeType ? (
      <Stack align="center" justify="center" width="100%">
        <Loader size="large" />
      </Stack>
    ) : (
      <DocRendererComp
        url={url}
        fileName={fileName}
        filePreviewDataSource={filePreviewDataSource}
        {...restProps}
      />
    )
  ) : null;
};

export { FilePreviewer };
